export default __webpack_public_path__ + "static/media/reviewPreview@2x.10be740a.png";